<template>
  <ModalDialog
    ref="dialog"
    title="Edit Credit Status"
    icon="fa-credit-card"
    :submitting="submitting"
    submitTitle="Update"
    :submitDisabled="creditAccountWarning"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="creditForm" :labelColumnSize="3">
      <div class="alert alert-warning" v-if="creditAccountWarning">
        <i class="far fa-exclamation-triangle"> </i> &nbsp; <strong>Warning:</strong> Cannot set a credit account until Credit Details are filled in for this contact
      </div>
      <FormRow label="Credit Type"><FormSelect v-model="credit.creditType" field="creditType" :options="creditTypeOptions" /></FormRow>

      <span v-show="credit.creditType == creditTypes.account">
        <FormRow label="Credit Status"><FormSelect  v-model="credit.creditStatus" field="creditStatus" :options="creditStatusOptions" /></FormRow>
        <FormRow label="Credit Limit"><FormInputCurrency v-model="credit.creditLimit" field="creditLimit" /></FormRow>
        <FormRow label="Minimum Spend"><FormInputCurrency v-model="credit.minSpendRequired" field="minSpendRequired" addon="Per Month" note="Set to zero for no minimum monthly spend" /></FormRow>
        <FormRow label="Minimum Spend - Admin Fee"><FormInputCurrency v-model="credit.minSpendAdminFee" field="minSpendAdminFee" note="Set to zero for no minimum spend admin fee" /></FormRow>
        <FormRow label="Payment Terms">
          <div class="input-group input-payment-terms-group">
            <FormInputText v-model="credit.paymentTermsAmount" field="paymentTermsAmount" class="input-group-prepend" />
            <FormSelect v-model="credit.paymentTermsType" :options="paymentTermOptions" field="paymentTermsType" />
          </div>
        </FormRow>   
      </span>

      <FormRow label="Log Message"><FormInputTextArea placeholder="Reason for change" v-model="credit.note" field="note" /></FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'
import { CreditTypeLookup, CreditStatusLookup, CreditTypes, CreditStatusTypes, PaymentTermLookup, ContactEntityTypes } from '@/store/types'

export default {
  name: "ContactEditCreditStatusDialog",
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    contactId: Number,
    isCreateMode: Boolean
  },
  data() {
    return {
      credit: {
      },
      creditForm: {},
      existingCreditType: '',
      submitting: false,
      creditTypeOptions: CreditTypeLookup,
      creditStatusOptions: CreditStatusLookup,
      creditTypes: CreditTypes,
      creditStatusTypes: CreditStatusTypes,
      paymentTermOptions: PaymentTermLookup
    }
  },
  mounted() {

  },
  computed: {
    currentCreditType() {
      var curType = this.creditTypeOptions.filter(status => { return status.value == this.existingCreditType })[0]
      if(curType)
        return curType.name
      return ''
    },
    creditAccountWarning() {
      if(this.credit.creditType == CreditTypes.account) {
        if(this.credit.tradingName == null || this.credit.tradingName == '')
          return true
        if(this.credit.abn == null || this.credit.abn == '')
          return true
        if(this.credit.entityType == null || this.credit.entityType == ContactEntityTypes.none)
          return true
      }
      return false
    }
  },
  methods: {
    show(credit) {
      // Reset form
      this.credit = { }
      this.creditForm = {}
      this.submitting = false

      if(credit != null) {
        this.credit = _.cloneDeep(credit)
        this.existingCreditType = this.credit.creditType
      }

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var creditData = _.cloneDeep(this.$data.credit)
      creditData = _.pick(creditData, [
        'creditType', 'creditStatus', 'creditLimit', 'minSpendRequired', 'minSpendAdminFee', 'paymentTermsAmount', 'paymentTermsType', 'note'
      ])
      creditData.creditLimit = this.sanitizeCurrency(creditData.creditLimit)

      this.$apiService.contactService.updateContactCreditStatus(this.contactId, creditData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.creditForm = this.processFormResponse(err)
        })
    }
  }
}
</script>